import type { BigNumberish } from 'ethers'
import type { ContractNFCS } from 'modules/contracts/contracts'

export async function getTokenEvent(
  tokenContract: ReturnType<typeof ContractNFCS.factory.connect>,
  recipient: string,
  tokenId: BigNumberish | null,
) {
  // TODO: timestamp?
  const filter = tokenContract.filters.TokenMinted(null, recipient, tokenId)
  const events = await tokenContract.queryFilter(filter)
  const event = events[0]
  if (!events[0] || !event.decode) {
    throw new Error('TokenMinted event parsing error')
  }
  const decoded = event.decode(event.data, event.topics)
  return {
    raw: event,
    decoded,
  }
}
